/**
 * CoSingery — **登入頁樣式常數**（`decisions/044`）
 *
 * 為何抽檔：登入頁要守住硬規則 B（逐檔 ≤200 行）；呢幾個 inline style 物件佔咗廿幾行。
 * ⚠️ 一律用設計 token（硬規則 D：唔准硬編碼色／字級）；色值只用 var(--…) 或 fallback。
 */
export const LOGIN_CARD: React.CSSProperties = {
  background: 'var(--color-surface)',
  border: '1px solid var(--color-divider)',
  borderRadius: '14px',
  padding: '18px',
  display: 'grid',
  gap: '10px',
  maxWidth: '420px',
  margin: '0 auto',
};

export const LOGIN_INPUT: React.CSSProperties = {
  fontSize: 'var(--font-size-body, 19px)',
  padding: '12px 14px',
  borderRadius: '10px',
  border: '1px solid var(--color-divider)',
  background: 'var(--color-bg)',
  color: 'var(--color-text)',
  width: '100%',
};

export const LOGIN_BTN: React.CSSProperties = {
  fontSize: 'var(--font-size-button, 18px)',
  padding: '12px 16px',
  borderRadius: '999px',
  border: '1px solid var(--color-accent)',
  background: 'var(--color-accent)',
  color: 'var(--color-on-accent)',
  cursor: 'pointer',
};
